import ErrorComponent from '@lib/tools/views/web/components/Error';

export const ErrorContainer = () => <ErrorComponent />;
